import { SEND_INVITE } from '../actionTypes'

export const sendInvite = (data: object) => ({
  type: SEND_INVITE.name,
  api: {
    url: 'guests/send_invite',
    data,
  },
})
